import React from "react";
import { AiFillEye } from "react-icons/ai";

const BestProducts: React.FC<any> = ({ columns, data, onView }) => {
  const getBgColor = (text: string) => {
    if (text === "Pending") {
      return "#fa761e";
    } else {
      return "#005ec9";
    }
  };
  return (
    <div className="mt-4 bg-white shadow-sm p-2">
      <h3 className="text-md font-semibold">Most selling products</h3>
      <div className="relative mt-3 overflow-x-auto max-h-[45vh] hide-scrollbar overflow-auto  sm:rounded-lg">
        <table className="w-full text-sm text-left  text-gray-500 font-poppins">
          <thead className="text-xs text-gray-500 sticky top-0 uppercase  bg-white ">
            <tr>
              {columns &&
                columns.map((column: any) => (
                  <th key={column} scope="col" className="px-6 py-3">
                    {column}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="overflow-y-auto">
            {data &&
              data.map((item: any) => (
                <tr key={item.Oid} className="odd:bg-[#fafafa]">
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.id}
                  </td>
                    <td className="px-6 ">
                    <img
                      src={item.image_url}
                      className="w-10 h-10 rounded-md"
                    />
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                     <h3 className="font-poppins text-black font-semibold text-[0.9rem]">
                          {item.title}
                        </h3>
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                   {item.description}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    £{item.price}
                  </td>              
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BestProducts;
